
import { css } from 'lit';
export default css`
:host {margin-bottom: 2rem;display: block
}@media (min-width: 1024px) {:host {margin-bottom: 4rem
    }
}
`;